<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_doc_orderDocFileType') || '文档类型'"
            prop="fileType"
          >
            <dict-select
              v-model="formData.fileType"
              size="medium"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.order_form_pe_file_type') || '请选择文档类型'"
              style="width: 100%"
              filterable
              clearable
              :body="fileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_form_label_title_is_common') || '是否通用文档'"
            prop="isCommon"
          >
            <el-col>
              <el-radio-group v-model="formData.isCommon">
                <el-radio label="Y">
                  {{ $l('INDEX.order_form_item_currency') || '通用' }}
                </el-radio>
                <el-radio label="N">
                  {{ $l('INDEX.order_form_item_specify_goods') || '指定产品' }}
                </el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.order_doc_fileName') || '文件名'">
            <el-input v-model="formData.fileName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="'N' === formData.isCommon">
        <OrderGoods
          :changeOrderCode="changeOrderCode"
          :orderGoodsPackageDocCode="orderGoodsPackageDocCode"
          ref="orderGoodsTable"
        />
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import OrderGoods from '../order-goods'
export default {
  mixins: [EditLoading],
  components: { OrderGoods },
  props: {
    changeOrderCode: String,
    changeOrderGoodsPackageDocCode: String,
    orderGoodsPackageDocCode:String,
  },
  data() {
    return {
      fileTypeParams: { dictType: 'fileType' },
      formData: {},
      rules: {
        fileType: [
          {
            required: true,
            message: this.$l('INDEX.order_form_pe_file_type') || '请选择文档类型',
            trigger: 'change',
          },
        ],
        isCommon: [
          {
            required: true,
            message: this.$l('INDEX.order_form_pe_is_common') || '请选择是否通用文档',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.changeOrderGoodsPackageDocCode) return
      this.$api
        .changeOrderGoodsPackageDocDetailApi({
          changeOrderGoodsPackageDocCode: this.changeOrderGoodsPackageDocCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      let listOrderGoodsCode = []
      if (this.formData.isCommon === 'N') {
        const listOrderGoods = this.$refs.orderGoodsTable.getTableData()
        if (!listOrderGoods || !listOrderGoods.length) {
          this.$message.warning(`请选择指定的产品`)
          return
        }
        listOrderGoodsCode = listOrderGoods.map((item) => item.orderGoodsCode)
      }

      this.loadingOpen()

      const params = {
        ...this.formData,
        changeOrderCode: this.changeOrderCode,
        listOrderGoodsCode,
      }

      this.$api
        .changeOrderGoodsPackageDocUpdateApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('table_Upload_failed') || '上传失败')
            return
          }
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.uploader_message_status_success') || '上传成功',
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
